import { FC, memo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { IonSpinner } from '@ionic/react'

import { EmptyAvatarBackground } from '../assets/EmptyAvatarBackground'
import { Plus } from '../assets/Plus'

interface EmptyAvatarProps {
  className?: string
  hasText?: boolean
  hasIcon?: boolean
  uploading?: boolean
  isValid?: boolean
}

const EmptyAvatarComponent: FC<EmptyAvatarProps> = ({
  className,
  hasText,
  hasIcon,
  uploading,
  isValid = true,
}) => {
  const { t } = useTranslation('common')

  return (
    <div className="absolute top-0 left-0">
      <div
        className={`w-full h-full relative flex justify-center items-center ${className}`}
      >
        <EmptyAvatarBackground isValid={isValid} margin={4} />
        {hasText && !uploading && (
          <span className="text-white text-center font-bold absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 w-full">
            <Trans>{t('registration.profile.avatarIsRequired')}</Trans>
          </span>
        )}
        {!uploading && hasIcon && (
          <Plus className="w-7 h-7 absolute top-0 right-1" />
        )}
        {uploading && <IonSpinner color="main" className="absolute" />}
      </div>
    </div>
  )
}

export const EmptyAvatar = memo(EmptyAvatarComponent)
